import React from 'react';
import { withRouter } from 'react-router-dom';

class GridOrc extends React.Component {

    constructor() {

        super();

        this.state = {
            pageNum: 1,
            totalPages: 0,
            pages: [[]]
        };

        this.pageDown = this.pageDown.bind(this);
        this.pageUp = this.pageUp.bind(this);

    }

    pageDown() {

        if (this.state.pageNum > 1) {
            this.setState({ pageNum: this.state.pageNum - 1 });
        }

    }

    pageUp() {

        if (this.state.pageNum < this.state.totalPages) {
            this.setState({ pageNum: this.state.pageNum + 1 });
        }

    }

    componentDidMount() {

        let tp = this.props.data.length / this.props.pageSize;

        if (tp > parseInt(tp)) {
            this.setState({ totalPages: parseInt(tp) + 1 });
        } else {
            this.setState({ totalPages: parseInt(tp) });
        }

        let p = 0;

        for (let i = 0; i < this.props.data.length; i++) {

            if (i % this.props.pageSize === 0 && i !== 0) {

                p++;
                this.state.pages.push([]);
                this.state.pages[p].push(this.props.data[i]);

            } else {

                this.state.pages[p].push(this.props.data[i]);

            }

        }

    }

    render() {
        return(
            <div id="grid2">
                <table>
                    <thead>
                        <tr>
                            { this.props.header.map((h, i) => <th key={ i }>{ h }</th> ) }
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.pages[this.state.pageNum - 1].map((row, i) => 
                            <tr key={ i }>
                                <td>{ row.data[0] }</td>
                                <td>{ row.data[1] !== null && ("R$ " + row.data[1]) }</td>
                                <td>{ row.data[2] !== null && ("R$ " + row.data[2]) }</td>
                                <td>{ row.data[3] !== null && ("R$ " + row.data[3]) }</td>
                                <td>{ row.data[4] !== null && ("R$ " + row.data[4]) }</td>
                                <td>{ row.data[5] !== null && ("R$ " + row.data[5]) }</td>
                                <td>{ row.data[6] !== null && ("R$ " + row.data[6]) }</td>
                                <td>{ row.data[7] !== null && ("R$ " + row.data[7]) }</td>
                                <td>{ row.data[8] !== null && ("R$ " + row.data[8]) }</td>
                                <td>{ row.data[9] !== null && ("R$ " + row.data[9]) }</td>
                                <td>{ row.data[10] !== null && ("R$ " + row.data[10]) }</td>
                                <td>{ row.data[11] !== null && ("R$ " + row.data[11]) }</td>
                                <td>{ row.data[12] !== null && ("R$ " + row.data[12]) }</td>
                                <td>{ row.data[13] !== null && ("R$ " + row.data[13]) }</td>
                                <td>{ row.data[14] }</td>
                            </tr>) }
                    </tbody>
                </table><br />
                <button type="button" onClick={ this.pageDown }>
                    { '<' }
                </button>
                <b> { this.state.pageNum } / { this.state.totalPages } </b>
                <button type="button" onClick={ this.pageUp }>
                    { '>' }
                </button>
            </div>
        );
    }

}

export default withRouter(GridOrc);

